module.exports = __webpack_public_path__ + "static/img/224_TO8_1955_og.70516a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/224_TO8_1955_og.jpg
// module id = HaRr
// module chunks = 0